import isEmpty from 'lodash.isempty';
import { COUNTRIES_MAP } from 'constants/countries';

export const getLocationByCode = (locationCode: string[]) => {
  if (isEmpty(locationCode)) return [];
  return locationCode.map((code: any) => {
    return COUNTRIES_MAP[code];
  });
};
